module.exports = __webpack_public_path__ + "img/Free Response 10.1c69d3e5.png";